import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {URL_NOVO_PORTAL} from '../util/constants';
import {StorageService} from '../services/storage.service';

@Injectable()
export class HomeRedirectGuard implements CanActivate {

  constructor(private storage: StorageService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const token = this.storage.getObjLogin();
      if (token) {
        const param = new URLSearchParams(token);
        this.storage.clearAll();
        window.open(`${URL_NOVO_PORTAL}/login?${param.toString()}`, '_self');
      } else {
        window.open(`${URL_NOVO_PORTAL}`, '_self');
      }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/home-redirect.guard.ts